import { Flex, Box } from '@chakra-ui/layout';
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/modal';
import { Label, Loading, CustomIcon } from 'components';
import { demandStatusLabels } from 'constants/demands';
import { format, parse } from 'date-fns';
import { useBoolean } from 'hooks/useBoolean';
import { memo, useCallback, useEffect, useState } from 'react';
import { getBudgetControlServiceById, IGetBudgetControlServiceById } from 'services/budgetControl';
import { formatDateToBr } from 'utils/date';
import { formatCurrency } from 'utils/number';

import * as Styles from './styles';

interface IProps {
  open: boolean;
  onClose(): void;
  serviceId?: number;
}

const ServiceModalComponent = ({ onClose, open, serviceId }: IProps): JSX.Element => {
  const [isLoading, setIsLoading] = useBoolean(true);
  const [data, setData] = useState<IGetBudgetControlServiceById>();

  const handleGetData = useCallback(async () => {
    setIsLoading(true);
    try {
      if (serviceId) {
        const response = await getBudgetControlServiceById(serviceId);
        setData(response.data);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [serviceId]);

  useEffect(() => {
    handleGetData();
  }, [open]);

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalOverlay />

      <ModalContent maxW="45rem">
        <Styles.Container>
          {isLoading && data ? (
            <Loading text="Carregando dados..." />
          ) : (
            <>
              <Styles.Header>
                <h1>{data?.demanda}</h1>

                <Box
                  bg="brand.1300"
                  borderRadius="50%"
                  fontSize="21px"
                  fontWeight="bold"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  textAlign="center"
                  as="button"
                  type="button"
                  border="none"
                  color="brand.gray300"
                  onClick={onClose}
                >
                  <CustomIcon size="22px" $noSphere icon="round_close" />
                </Box>
              </Styles.Header>

              <Styles.Hr />

              <Flex w="100%" direction="column" gridGap="2rem">
                <Flex flex={1} justifyContent="space-between">
                  <Flex direction="column">
                    <Label color="#5a6467">Autor da demanda</Label>

                    <Styles.Paragraph>
                      {data?.autorDemanda}
                      {/* / {data?.areaDemandante} */}
                    </Styles.Paragraph>
                  </Flex>

                  <Flex direction="column">
                    <Label color="#5a6467">Data da solicitação</Label>

                    <Styles.Paragraph>{formatDateToBr(data?.createdAt || '')}</Styles.Paragraph>
                  </Flex>
                  {/* <Flex direction="column">
                    {!!data?.prazo && (
                      <Flex direction="column">
                        <Label>Prazo</Label>
                        <Styles.Paragraph>
                          {format(new Date(data?.prazo), 'dd/MM/yyyy')}
                        </Styles.Paragraph>
                      </Flex>
                    )}
                  </Flex> */}
                </Flex>

                <Flex fontStyle="italic">
                  <Styles.ParagraphItalic>{data?.descricaoTrabalho}</Styles.ParagraphItalic>
                </Flex>

                <Styles.LawyerBox>
                  <Flex gridGap=".2rem" align="center" width="100%">
                    <Styles.LawyerBoxContent>Advogado (a):</Styles.LawyerBoxContent>

                    {data?.lawyer?.name && (
                      <Styles.LawyerBoxContent
                        style={{
                          textAlign: 'left',
                          width: '50%',
                          fontWeight: 400,
                          paddingLeft: '10px',
                          fontSize: '14px',
                        }}
                      >
                        {data?.lawyer.name}
                      </Styles.LawyerBoxContent>
                    )}
                  </Flex>

                  <Flex align="center" ml="auto" gridGap="2rem">
                    <Flex align="center" gridGap=".5rem">
                      <Styles.LawyerBoxContent>Horas:</Styles.LawyerBoxContent>

                      <Styles.Paragraph style={{ fontWeight: 400 }}>
                        {/* DUAS FORMAS DE MOSTRAR OS VALORES DE HORAS */}
                        {
                          String(data?.horas)
                          /* {String(data?.horas).slice(0, 6).endsWith(':')
                          ? String(data?.horas).slice(0, 5)
                          : String(data?.horas).slice(0, 6)} */
                        }
                      </Styles.Paragraph>
                    </Flex>

                    <Flex align="center" gridGap=".5rem">
                      <Styles.LawyerBoxContent>Valor:</Styles.LawyerBoxContent>

                      <Styles.Paragraph style={{ fontWeight: 400 }}>
                        {formatCurrency(data?.valor || 0)}
                      </Styles.Paragraph>
                    </Flex>
                  </Flex>
                </Styles.LawyerBox>
              </Flex>

              <Flex direction="column" gridGap=".8rem">
                <h1>Histórico</h1>
                <Styles.Hr />

                {data?.historico
                  .sort((historicA, historicB) => (historicA.id < historicB.id ? 1 : -1))
                  .map(historic => (
                    <>
                      {/* <Styles.Hr notMargin small /> */}

                      <Styles.HistoryContent>
                        Status alterado para{' '}
                        <strong>
                          {demandStatusLabels[historic.status]} em{' '}
                          {format(
                            parse(historic.data, 'yyyy-MM-dd HH:mm:ss', new Date()),
                            `dd/MM/yyyy 'às' HH:mm`,
                          )}
                        </strong>
                      </Styles.HistoryContent>
                    </>
                  ))}
              </Flex>
            </>
          )}
        </Styles.Container>
      </ModalContent>
    </Modal>
  );
};

export const ServiceModal = memo(ServiceModalComponent);
